import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast';

import CustomInputV2 from '../../../common/CustomInputV2';
import CustomActionButton from '../../../common/CustomActionButton';

import { delay, generateRandomNumber } from '../../../utils';
import { SendVerificationCode, DeactivateCompanyUsers, } from '../../../redux/company/actions';

const DeactivateCompany = (props) => {
    const { organization, setWrapperChanger } = props;
    const [sentCode, setSentCode] = useState("");
    const [code, setCode] = useState('');
    const [codeVerified, setCodeVerified] = useState(false);
    const [status, setStatus] = useState(0);
    const [attempts, setAttempts] = useState(3);

    const sideIcon = [
        "",
        <CircularProgress sx={{ color: '#d1d1d1' }} className="verif-loader" />,
        <CheckCircleIcon sx={{ fontSize: 30, color: '#99B93C', mr: -1 }} />,
        <CancelIcon sx={{ fontSize: 30, color: 'red', mr: -1 }} />,
    ]

    const GenerateNumber = () => {
        let number = generateRandomNumber(999999);
        number = (number + "").padStart(6, "0");
        setSentCode(number);

        return;
    }

    useEffect(async () => {
        if (sentCode && organization.table_id) {
            const res = await props.SendVerificationCode(organization?.name, sentCode);
            if (!res) {
                toast.error("Unable to send verification code.");
            }
        }
    }, [sentCode]);

    useEffect(() => {
        GenerateNumber();
    }, []);

    return (
        <div className='flex-c'>
            <div style={{ width: "100%", maxWidth: "400px" }}>
                <p className='text-center text-red'>Warning: Deactivating {organization?.name} will deactivate all subscriptions for this company.</p>
                <p className='text-center'>A one-time code has been sent to Steve Gonser. It will expire in 10 mins.</p>
                {/* <p className='text-center text-red'>*** {attempts} ATTEMPTS REMAINING ***</p> */}
                <Box display="flex" sx={{ justifyContent: 'center', mb: '20px' }}>
                    <CustomInputV2
                        placeholder="Enter Code"
                        value={code}
                        onChange={(e) => {
                            setCode(e.target.value);
                            setStatus(1);
                        }}
                        onBlur={() => {
                            delay(() => {
                                if (code == sentCode) {
                                    setStatus(2);
                                    setCodeVerified(true);
                                } else {
                                    setStatus(3);
                                    setCodeVerified(false);
                                }
                            }, 2000)
                        }}
                        style={{ textAlign: "center" }}
                        RightIcon={sideIcon[status]}
                    />
                </Box>
                <Box display="flex" sx={{ justifyContent: 'space-between' }}>
                    <button className='secondary-button' onClick={() => setWrapperChanger('')}>BACK</button>
                    <CustomActionButton disabled={!codeVerified} action={async () => {
                        let toastId = toast.loading('Deactivating Company Users...')

                        const res = await props.DeactivateCompanyUsers(organization.table_id);
                        if (res.success) {
                            toast.success('Successfully deactivated all users.', {
                                id: toastId,
                            });

                            delay(() => {
                                setWrapperChanger();
                            }, 1000)

                            return true;
                        } else {
                            if (res.type == 1) {
                                toast.error('Failed to deactivate all users!', {
                                    id: toastId,
                                });
                            } else if (res.type == 0) {
                                toast.error('Deactivation process interrupted!', {
                                    id: toastId,
                                });
                            }
                            return false;
                        }
                    }}>SUBMIT</CustomActionButton>
                </Box>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    SendVerificationCode,
    DeactivateCompanyUsers,
})(DeactivateCompany);
